import type { Board, Team } from '../lib/types';

export function AktiveBingoaufgaben({ board, teamId, teams }: { board: Board | null; teamId?: string; teams: Team[] }) {
  const team = teams.find(t => t.id === teamId);
  return <section className="panel">
    <h2>Alle aktiven Bingoaufgaben</h2>
    {team && <p className="muted small">Team: {team.name}</p>}
    {!board ? <p className="muted">Für dieses Team ist noch kein aktives Board vorhanden.</p> :
      <div className="aktive-aufgaben-grid">{board.cells.map(cell => {
        const erledigt = !!teamId && cell.teamIds.includes(teamId);
        return <article key={cell.index} className="aktive-aufgabe" style={erledigt && team ? { borderColor: team.color, backgroundColor: `${team.color}35` } : undefined}>
          <div className="row" style={{ justifyContent: 'space-between' }}>
            <strong>{cell.index + 1}. {cell.title}</strong>
            {erledigt && <span className="small">✓ Erledigt</span>}
          </div>
          <p className="muted small">{cell.description || 'Keine Beschreibung vorhanden.'}</p>
        </article>;
      })}</div>}
  </section>;
}
